import {
  selectCameraStreamByPeerID,
  selectIsPeerAudioEnabled,
  selectIsPeerVideoEnabled,
  useHMSActions,
  useHMSStore,
} from "@100mslive/react-sdk";

import React from "react";
import MicIcon from "@mui/icons-material/Mic";
import MicOffIcon from "@mui/icons-material/MicOff";
import VideocamIcon from "@mui/icons-material/Videocam";
import VideocamOffIcon from "@mui/icons-material/VideocamOff";
const HostVideoTile = ({ peer, isLocal, mirrorVideo, isHost = true }) => {
  const hmsActions = useHMSActions();
  const videoRef = React.useRef(null);
  const videoTrack = useHMSStore(selectCameraStreamByPeerID(peer.id));
  const audioOn = useHMSStore(selectIsPeerAudioEnabled(peer.id));
  const videoOn =useHMSStore(selectIsPeerVideoEnabled(peer.id));
  React.useEffect(() => {
    const videoElement = videoRef.current;
    if (!videoElement || !videoTrack) return;

    (async () => {
      if (videoTrack.enabled) {
        await hmsActions.attachVideo(videoTrack.id, videoElement);
      } else {
        await hmsActions.detachVideo(videoTrack.id, videoElement);
      }
    })();

    return () => {
      if (videoTrack?.id) {
        hmsActions.detachVideo(videoTrack.id, videoElement);
      }
    };
  }, [videoTrack?.id, videoTrack?.enabled, hmsActions]);

  return (
    <div className="host-video-container"   >
      <video
        ref={videoRef}
        autoPlay={true}
        playsInline
        muted={true}
           
        className={
          peer?.isLocal && !mirrorVideo
            ? "peer-host-video"
            : "peer-video-host-full"
        }
      ></video>
      <div className="peer-name-host">
        {peer?.isLocal
          ? `${peer?.name} (You)`
          : isHost
          ? `${peer?.name} (Host)`
          : peer?.name}
      </div>
      <div className="peer-name-host-multiple-peer">
        {peer?.isLocal
          ? `${peer?.name} (You)`
          : isHost
          ? `${peer?.name} (Host)`
          : peer?.name}
      </div>
        <div className="peer-audio-video-status">
        {videoOn ? <VideocamIcon /> : <VideocamOffIcon />}
        {audioOn ? <MicIcon /> : <MicOffIcon />}
      </div>
    </div>
  );
};

export default HostVideoTile;
